module.exports = __webpack_public_path__ + "img/zw.f58a1b7.svg";